import { Button,  TextareaAutosize, LinearProgress,Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core'
import React, { useRef, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import axios from 'axios'
import "../styles/AdminApplicationsView.css"
import { myBucket } from '../services/UploadService'
import { ApiURL } from '../constants/ApiUrl'
import { findLastKey } from 'lodash'
// import { Document, Page,pdfjs } from 'react-pdf';

function AdminApplicationsView() {
    const [update, setUpdate] = useState(false)
    const [Progress, setProgress] = useState(0)
    const [Progress1, setProgress1] = useState(0)
    const [Progress2, setProgress2] = useState(0)
    const [Progress3, setProgress3] = useState(0)
    const [Progress4, setProgress4] = useState(0)
    const [Progress5, setProgress5] = useState(0)
    const [IsOpen1,setIsOpen1]=useState(false)
    const [Editable, setEditable] = useState(false)
    const [TempDetails, setTempDetails] = useState({})
    const [allDetails, setallDetails] = useState([])
    const [AppList, setAppList] = useState([])
    const [date, setDate] = useState("")
    const [subject, setSubject] = useState("")
    const [tempstatus, setTempStatus] = useState("")

    const [firstImg, setFirstImg] = useState({})
    const [secondImg, setSecondImg] = useState({})
    const [thirdImg, setThirdImg] = useState({})
    const [fourthImg, setFourthImg] = useState({})
    const [fifthImg, setFifthImg] = useState({})

    const [allPdf, setallPdf] = useState([])
    const [temppdf, setTempPdf] = useState([])
    const [sendMeMail,setSendMeMail]=useState(false)
    const [imgList, setImgList] = useState([])
    const [tempImgList, setTempImgList] = useState([])
    const value = localStorage.getItem("Notice")

    useEffect(() => {
        getData(value)
    }, [])
    const handleSend= async()=>{
        setSendMeMail(false)
        setIsOpen1(false)
        console.log(TempDetails,"ddddddd")
        if(tempstatus== "Active"){
            const result1 = await axios.post(`${ApiURL}/Notice_mail_to_all_users`,{
             userType:TempDetails.userType,
             title:TempDetails.subject
         })
         
         alert(result1.data)
        }
        setEditable(false);
       
    }

    const handleEdit = async () => {
        setSendMeMail(false)
        if (Editable) {
            setEditable(false);
        }
        else {
            const result = await axios.get(`${ApiURL}/api/get_notice_by_id/${value}`);
            setDate(result.data.msg.createdAt)
            setTempDetails(result.data.msg)
            const pdfList = []
            setAppList(result.data.msg.urls)
            setTempStatus(result.data.msg.status)
            result.data.msg.urls.map((item) => {
                if (item.path !== undefined) {
                    a.push(item.path)
                    const key = item.key.split("/")[2].split(".")[0]
                    if (key === "firstImg") {
                        pdfList.push(key)
                        setFirstImg(item)
                    }
                    else if (key === "secondImg") {
                        pdfList.push(key)
                        setSecondImg(item)
                    }
                    else if (key === "thirdImg") {
                        pdfList.push(key)
                        setThirdImg(item)
                    }
                    else if (key === "fourthImg") {
                        pdfList.push(key)
                        setFourthImg(item)
                    }
                    else if (key === "fifthImg") {
                        pdfList.push(key)
                        setFifthImg(item)
                    }
                }
            })

            setTempPdf(pdfList)
            setTempImgList(a)
            console.log(temppdf,"kkkkk")
            

            // setTempDetails(allDetails);
            setEditable(true);
        }
    }

    const handleChange = (e) => {
        // setSubject(e.target.value)

        setTempDetails({ ...TempDetails, [e.target.name]: e.target.value });
        console.log(TempDetails);
    }

    const handleFileChange = (e) => {
        const slug = TempDetails.subject.replace(/\s+/g, "-")
        let files = e.target.name
        if (files === "firstImg") {
            const file = e.target.files;
            let ext = file[0].name.split('.').pop().toLowerCase();
            if (file.length === 0) {
                return;
            }
            if (ext !== "pdf" && ext !== "jpg" && ext !== "jpeg" && ext !== "bmp" && ext !== "png") {
                alert("Only Pdf,jpg,jpeg,bmp,png files allowed");
                return;
            }
            const params = {
                ACL: 'public-read',
                Body: file[0],
                Bucket: process.env.REACT_APP_Bucket,
                Key: `Notices/${slug}/${files}.${ext}`
            }
            myBucket.putObject(params)
                .on('httpUploadProgress', (evt) => {
                    setProgress1(Math.round((evt.loaded / evt.total) * 100))
                })
                .send((err, data) => {
                    if (err) console.log(err)
                    else {
                        const first = (`https://${process.env.REACT_APP_Bucket}.s3.ap-south-1.amazonaws.com/Notices/${slug}/${files}.${ext}`);
                        setFirstImg({ path: first, key: params.Key })

                    }
                })
        }

        else if (files === "secondImg") {
            const file = e.target.files;
            let ext = file[0].name.split('.').pop().toLowerCase();
            if (file.length === 0) {
                return;
            }
            if (ext !== "pdf" && ext !== "jpg" && ext !== "jpeg" && ext !== "bmp" && ext !== "png") {
                alert("Only Pdf,jpg,jpeg,bmp,png files allowed");
                return;
            }
            const params = {
                ACL: 'public-read',
                Body: file[0],
                Bucket: process.env.REACT_APP_Bucket,
                Key: `Notices/${slug}/${files}.${ext}`
            }
            myBucket.putObject(params)
                .on('httpUploadProgress', (evt) => {
                    setProgress2(Math.round((evt.loaded / evt.total) * 100))
                })
                .send((err, data) => {
                    if (err) console.log(err)
                    else {
                        const second = (`https://${process.env.REACT_APP_Bucket}.s3.ap-south-1.amazonaws.com/Notices/${slug}/${files}.${ext}`);
                        setSecondImg({ path: second, key: params.Key })
                    }
                })
        }
        else if (files === "thirdImg") {
            const file = e.target.files;
            let ext = file[0].name.split('.').pop().toLowerCase();
            if (file.length === 0) {
                return;
            }
            if (ext !== "pdf" && ext !== "jpg" && ext !== "jpeg" && ext !== "bmp" && ext !== "png") {
                alert("Only Pdf,jpg,jpeg,bmp,png files allowed");
                return;
            }
            const params = {
                ACL: 'public-read',
                Body: file[0],
                Bucket: process.env.REACT_APP_Bucket,
                Key: `Notices/${slug}/${files}.${ext}`
            }
            myBucket.putObject(params)
                .on('httpUploadProgress', (evt) => {
                    setProgress3(Math.round((evt.loaded / evt.total) * 100))
                })
                .send((err, data) => {
                    if (err) console.log(err)
                    else {
                        const third = (`https://${process.env.REACT_APP_Bucket}.s3.ap-south-1.amazonaws.com/Notices/${slug}/${files}.${ext}`);
                        setThirdImg({ path: third, key: params.Key })
                    }
                })
        }
        else if (files === "fourthImg") {
            const file = e.target.files;
            let ext = file[0].name.split('.').pop().toLowerCase();
            if (file.length === 0) {
                return;
            }
            if (ext !== "pdf" && ext !== "jpg" && ext !== "jpeg" && ext !== "bmp" && ext !== "png") {
                alert("Only Pdf,jpg,jpeg,bmp,png files allowed");
                return;
            }
            const params = {
                ACL: 'public-read',
                Body: file[0],
                Bucket: process.env.REACT_APP_Bucket,
                Key: `Notices/${slug}/${files}.${ext}`
            }
            myBucket.putObject(params)
                .on('httpUploadProgress', (evt) => {
                    setProgress4(Math.round((evt.loaded / evt.total) * 100))
                })
                .send((err, data) => {
                    if (err) console.log(err)
                    else {
                        const fourth = (`https://${process.env.REACT_APP_Bucket}.s3.ap-south-1.amazonaws.com/Notices/${slug}/${files}.${ext}`);
                        setFourthImg({ path: fourth, key: params.Key })
                    }
                })
        }
        else if (files === "fifthImg") {
            const file = e.target.files;
            let ext = file[0].name.split('.').pop().toLowerCase();
            if (file.length === 0) {
                return;
            }
            if (ext !== "pdf") {
                alert("Only Pdf,jpg,jpeg,bmp,png files allowed");
                return;
            }
            const params = {
                ACL: 'public-read',
                Body: file[0],
                Bucket: process.env.REACT_APP_Bucket,
                Key: `Notices/${slug}/${files}.${ext}`
            }
            myBucket.putObject(params)
                .on('httpUploadProgress', (evt) => {
                    setProgress5(Math.round((evt.loaded / evt.total) * 100))
                })
                .send((err, data) => {
                    if (err) console.log(err)
                    else {
                        const fifth = (`https://${process.env.REACT_APP_Bucket}.s3.ap-south-1.amazonaws.com/Notices/${slug}/${files}.${ext}`);
                        setFifthImg({ path: fifth, key: params.Key })

                    }
                })
        }
    }
    const a = []
    const handleUpdate = async () => {
        
        const result = await axios.post(`${ApiURL}/api/update_data_In_notice`, {
            "title": TempDetails.subject,
            "Notice": TempDetails.text,
            "status": tempstatus,
            "id": value,
        });
        const urls = [firstImg, secondImg, thirdImg, fourthImg, fifthImg]
        axios.post(`${ApiURL}/api/updateImage`, {
            "urls": urls,
            "id": value
        }).then((res) => {
            const result1 = JSON.parse(res.config.data)
            const pdfList = []
            result1.urls.map((item) => {
                if (item.path !== undefined) {
                    a.push(item.path)
                    const key = item.key.split("/")[2].split(".pdf")[0]
                    if (key === "firstImg") {
                        pdfList.push(key)
                    }
                    else if (key === "secondImg") {
                        pdfList.push(key)
                    }
                    else if (key === "thirdImg") {
                        pdfList.push(key)
                    }
                    else if (key === "fourthImg") {
                        pdfList.push(key)
                    }
                    else if (key === "fifthImg") {
                        pdfList.push(key)
                    }
                }
            })
            if (tempstatus == "Active") {
                setSendMeMail(true)
                alert(result.data.success)
                
            }
            else {
                setSendMeMail(false)
                alert(result.data.success)
                setEditable(false)
            }
            setallPdf(pdfList)
            setImgList(a)
            setallDetails(result.data.info)
           
            setUpdate(true)

        }).catch((err) => {
            console.log(err, "errrrrrr")
        })
    }

    const getData = async (value) => {
        const result = await axios.get(`${ApiURL}/api/get_notice_by_id/${value}`);
        setDate(result.data.msg.createdAt)
        setallDetails(result.data.msg)
        const pdfList = []
        setAppList(result.data.msg.urls)
        result.data.msg.urls.map((item) => {
            if (item.path !== undefined) {
                a.push(item.path)
                const key = item.key.split("/")[2].split(".pdf")[0]
                if (key === "firstImg") {
                    pdfList.push(key)
                }
                else if (key === "secondImg") {
                    pdfList.push(key)
                }
                else if (key === "thirdImg") {
                    pdfList.push(key)
                }
                else if (key === "fourthImg") {
                    pdfList.push(key)
                }
                else if (key === "fifthImg") {
                    pdfList.push(key)
                }
            }
        })
        setallPdf(pdfList)
        setImgList(a)

    }
    const handleNoApp=()=>{
        setIsOpen1(false)
        setEditable(false);
    }
    const sendMail=()=>{
        setIsOpen1(true)
    }
    return (
        <>
            <div>
                <div style={{ textAlign: 'center', padding: '0 0 50px 0' }}>
                    <h1>Notice</h1>
                    <div className="applicationContainer" style={{ width: "60%", margin: "auto" }}>
                        <table style={{ width: "700px" }} className="applicationTable">
                            <tr>
                                <td>
                                    <Button variant="contained"  onClick={handleEdit}>{Editable ? "Cancel" : "Edit"}</Button>
                                </td>
                                <td>
                                    {Editable && <Button variant="contained" color="primary" onClick={handleUpdate}>Update</Button>
                                    
                                    // <Button variant="contained" color="primary" style={{marginLeft:'20px'}} disabled={!sendMeMail} onClick={sendMail}>Send Mail</Button>
                                    }
                                    
                                </td>
                               
                            </tr>
                            <tr>
                                <td colSpan="2"><b><u>Notice Details</u></b></td>
                            </tr>
                            <tr>
                                <td>Title</td>
                                {
                                    Editable ?
                                        <input name="subject" value={TempDetails.subject} onChange={handleChange} /> :
                                        <td>{allDetails.subject}</td>
                                }
                            </tr>
                            <tr>
                                <td>Notice</td>
                                {
                                    Editable ?
                                        <TextareaAutosize name="text" minRows={10} style={{width:'580px'}}  value={TempDetails.text} onChange={handleChange} /> :
                                        <td>{allDetails.text}</td>
                                }


                            </tr>
                            <tr>
                                <td>Date</td>
                                <td>{new Date(date).getDate() + '/' + (new Date(date).getMonth() + 1) + '/' + new Date(date).getFullYear()}</td>
                            </tr>
                            <tr>
                                <td>Status</td>
                                {
                                    Editable ?
                                        <select className="newSelect" value={tempstatus} onChange={(e) => setTempStatus(e.target.value)}>
                                            <option name="status" value="Active">Active</option>
                                            <option name="status" value="Inactive">Inactive</option>

                                        </select>
                                        :
                                        <td>{allDetails.status}</td>
                                }
                            </tr>
                            <tr>
                                <td colSpan="2"><b><u>Attachments</u></b></td>
                            </tr>

                            {Editable ?
                                <>
                                    <tr>
                                        <td> File 1 </td>
                                        <td>
                                            <input name={temppdf[0]} type="file" onChange={handleFileChange} accept="file" />
                                            <td><a href={imgList[0]} target="_blank" >Click Here to View</a></td>
                                            <LinearProgress variant="determinate" value={Progress1}  />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td> File 2 </td>
                                        <td>
                                            <input name={temppdf[1]} type="file" onChange={handleFileChange} accept="file" />
                                            <td><a href={imgList[1]} target="_blank">Click Here to View</a></td>
                                            <LinearProgress variant="determinate" value={Progress2}  />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td> File 3 </td>
                                        <td>
                                            <input name={temppdf[2]} type="file" onChange={handleFileChange} accept="file" />
                                            <td><a href={imgList[2]} target="_blank" >Click Here to View</a></td>
                                            <LinearProgress variant="determinate" value={Progress3}  />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td> File 4 </td>
                                        <td>
                                            <input name={temppdf[3]} type="file" onChange={handleFileChange} accept="file" />
                                            <td><a href={imgList[3]} target="_blank" rel="noreferrer">Click Here to View</a></td>
                                            <LinearProgress variant="determinate" value={Progress4}  />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td> File  </td>
                                        <td>
                                            <input name={temppdf[4]} type="file" onChange={handleFileChange} accept="file" />
                                            <td><a href={imgList[4]} target="_blank" >Click Here to View</a></td>
                                            <LinearProgress variant="determinate" value={Progress5}  />
                                        </td>
                                    </tr>
                                </>
                                :
                                <>
                                    {imgList.map((itm, count) => (
                                        <tr>
                                            <td>File {count + 1} </td>
                                            {
                                                <td><a href={itm} target="_blank">Click Here to View</a></td>
                                            }
                                        </tr>
                                    ))}
                                </>
                            }


                        </table>
                    </div>
                </div>
            </div>
            <Dialog open={IsOpen1} >
                <DialogTitle >{"Update Data?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure, you want to Send Mail?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSend} color="primary">
                        Yes
                    </Button>
                    <Button onClick={handleNoApp} color="secondary">
                        No
                    </Button>
                </DialogActions>
            </Dialog>


        </>
    )
}
export default AdminApplicationsView
